import {
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import i18n from "../../../../i18n";
import { GrideDateFormatter } from "ui/Date";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { CLASSNAME } from "utils/constant";
import { FC } from "react";
import { formatNorwegianNumber } from "utils/helper";
import { calculateFieldStats } from "utils/statUtils";

let t = i18n.t;

export const pickListGridColumnItem = (data: any[] = []) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "registrationId",
			title: t("RegistrationIdShort"),
			className: `no-border`,
			footerCell: (props) => (
				<td className="td-bold no-border">
					{t("Total")}
				</td>
			),
			cells: {
				groupFooter: (props) => {
					if (props.dataItem?.field === "group1") {
						return <td className={`no-border td-bold`}></td>;
					} else {
						return (
							<td className={`no-border td-bold`}>
								<div style={{ marginTop: "20px" }}>
									Sum {props.dataItem.items[0].vesselName}
								</div>
							</td>
						);
					}
				},
			},
		},
		{
			field: "packageId",
			title: t("Package"),
			className: `no-border`,
		},
		{
			field: "salesDate",
			title: t("Date"),
			width: "150px",
			cells: {
				data: (props) => {
					return (
						<GrideDateFormatter
							date={props.dataItem.salesDate}
							formatType={"dd.MM.yyyy"}
						/>
					);
				},
			},
		},
		{
			field: "productName",
			title: t("Product"),
			cells: { data: (props) => <CellPopover {...props} /> },
			className: `no-border`,
		},
		{
			field: "buyerName",
			title: t("BuyerName"),
			className: `no-border`,
			cells: { data: (props) => <CellPopover {...props} /> },
		},
		{
			field: "netLiveWeightKg",
			title: t("Weight"),
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kg"} style={{}} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (props) => (
					<td className={`${CLASSNAME.TableNumeric} no-border td-bold`}>
						{`${formatNorwegianNumber(calculateFieldStats(data, "netLiveWeightKg").sum, 2, 2)} kg`}
					</td>
				),
				groupFooter: (props) => {
					let groupData = props.dataItem.aggregates.netLiveWeightKg;
					if (props.dataItem?.field === "group1") {
						return <td className={`no-border td-bold`}></td>;
					}
					return (
						<td className={`${CLASSNAME.TableNumeric} no-border td-bold`}>
							<div style={{ marginTop: "20px" }}>
								{`${formatNorwegianNumber(groupData.sum, 2, 2)} kg`}
							</div>
						</td>
					);
				},
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "price",
			title: t("Price"),
			width: "170px",
			cells: {
				data: (props) => <NumericalCell {...props} unit={"kr"} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "",
			title: "",
			width: "40px",
			className: `no-border`,
		},
	];
	return gridItems;
};

// export const NumericalHeader: FC<
// 	GridHeaderCellProps & { style?: React.CSSProperties } & any
// > = (props) => {
// 	return (
// 		<th style={{ ...props.style, textAlign: "end", paddingRight: "10px" }}>
// 			{props.title}
// 		</th>
// 	);
// };
